import React, { Component } from 'react';
import { Header, Container } from 'semantic-ui-react';
import moment from 'moment';

moment.locale("es");

class PasswordDisplayCoupon extends Component {

  constructor (props) {
    super(props);
  }

  componentDidMount () {
    window.print();
  }

  render () {
    const {username, password} = this.props.match.params
    
    return (
      <Container style={{margin: 20}}>
      <Header>
        Club de Tenis Corrientes
        <Header.Subheader>
        <a href="https://ctc.stanet.com.ar">https://ctc.stanet.com.ar</a>
        <table>
          <tr>
            <th style={{padding: 10, textAlign: "right"}}>Usuario</th>
            <td style={{textAlign: "left"}}>{username}</td>
          </tr>
          <tr>
            <th style={{padding: 10, textAlign: "right"}}>Contraseña</th>
            <td style={{textAlign: "left"}}>{password}</td>
          </tr>
        </table>
        <tr>
          <td style={{textAlign: "center"}}>{moment().format("dddd, MMMM Do YYYY, h:mm:ss a")}</td>
        </tr>
        </Header.Subheader>
      </Header>
      </Container>
    );
  }

}

export default PasswordDisplayCoupon;


// WEBPACK FOOTER //
// ./src/components/views/PasswordDisplayCoupon.jsx